/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { If, Then, Else } from "react-if";
import { Link } from "react-router-dom";
import { SVGIcon, theme } from "@nordcloud/gnui";

type Props = {
  target: string;
  search: boolean;
  value: string;
};

export function DetailLink({ target, search, value }: Props) {
  const showFileSearch = search && target != null;

  return (
    <If condition={showFileSearch}>
      <Then>
        <Link to={target}>
          {value}
          <SVGIcon
            name="search"
            size="sm"
            css={{
              cursor: "pointer",
              marginLeft: theme.spacing.spacing02,
              fill: theme.color.interactive.link,
              transform: "translateY(1px)",
            }}
          />
        </Link>
      </Then>
      <Else>
        <Link to={target}>{value}</Link>
      </Else>
    </If>
  );
}
